import React, { useState } from "react";
import { IoCloseOutline } from "react-icons/io5";
import "../../teacher_dashboard/lessons.css"; // reuse existing styles

const Setting = () => {
  const [profile, setProfile] = useState({
    name: "John Doe",
    email: "john@example.com",
    avatar: null,
  });

  const [passwordForm, setPasswordForm] = useState({
    current: "",
    newPassword: "",
    confirm: "",
  });

  const [notifications, setNotifications] = useState({
    email: true,
    push: false,
    sms: false,
  });

  const [preferences, setPreferences] = useState({
    theme: "light",
    language: "English",
  });

  // Modal for avatar upload
  const [avatarModal, setAvatarModal] = useState(false);
  const [selectedAvatar, setSelectedAvatar] = useState(null);

  // Save Profile
  const saveProfile = () => {
    alert("Profile Saved!");
    setAvatarModal(false);
  };

  // Save Password
  const savePassword = () => {
    if (passwordForm.newPassword !== passwordForm.confirm) {
      alert("Passwords do not match");
      return;
    }
    alert("Password Updated!");
    setPasswordForm({ current: "", newPassword: "", confirm: "" });
  };

  // Save Notifications
  const saveNotifications = () => {
    alert("Notification Preferences Saved!");
  };

  // Save Preferences
  const savePreferences = () => {
    alert("Preferences Saved!");
  };

  return (
    <div className="overview-container">
      <h2>Teacher Settings</h2>

      {/* ===== Profile Section ===== */}
      <div className="settings-card">
        <h3>Profile Info</h3>
        <div className="settings-row">
          <label>Name:</label>
          <input
            type="text"
            value={profile.name}
            onChange={(e) => setProfile({ ...profile, name: e.target.value })}
          />
        </div>
        <div className="settings-row">
          <label>Email:</label>
          <input
            type="email"
            value={profile.email}
            onChange={(e) => setProfile({ ...profile, email: e.target.value })}
          />
        </div>
        <div className="settings-row">
          <label>Avatar:</label>
          <button className="lesson-btn" onClick={() => setAvatarModal(true)}>
            Upload Avatar
          </button>
        </div>
        <button className="save-btn" onClick={saveProfile}>
          Save Profile
        </button>
      </div>

      {/* ===== Password Section ===== */}
      <div className="settings-card">
        <h3>Change Password</h3>
        <div className="settings-row">
          <label>Current Password:</label>
          <input
            type="password"
            value={passwordForm.current}
            onChange={(e) =>
              setPasswordForm({ ...passwordForm, current: e.target.value })
            }
          />
        </div>
        <div className="settings-row">
          <label>New Password:</label>
          <input
            type="password"
            value={passwordForm.newPassword}
            onChange={(e) =>
              setPasswordForm({ ...passwordForm, newPassword: e.target.value })
            }
          />
        </div>
        <div className="settings-row">
          <label>Confirm Password:</label>
          <input
            type="password"
            value={passwordForm.confirm}
            onChange={(e) =>
              setPasswordForm({ ...passwordForm, confirm: e.target.value })
            }
          />
        </div>
        <button className="save-btn" onClick={savePassword}>
          Update Password
        </button>
      </div>

      {/* ===== Notification Preferences ===== */}
      <div className="settings-card">
        <h3>Notifications</h3>
        <div className="settings-row">
          <label>Email:</label>
          <input
            type="checkbox"
            checked={notifications.email}
            onChange={(e) =>
              setNotifications({ ...notifications, email: e.target.checked })
            }
          />
        </div>
        <div className="settings-row">
          <label>Push Notifications:</label>
          <input
            type="checkbox"
            checked={notifications.push}
            onChange={(e) =>
              setNotifications({ ...notifications, push: e.target.checked })
            }
          />
        </div>
        <div className="settings-row">
          <label>SMS:</label>
          <input
            type="checkbox"
            checked={notifications.sms}
            onChange={(e) =>
              setNotifications({ ...notifications, sms: e.target.checked })
            }
          />
        </div>
        <button className="save-btn" onClick={saveNotifications}>
          Save Notifications
        </button>
      </div>

      {/* ===== Preferences ===== */}
      <div className="settings-card">
        <h3>Preferences</h3>
        <div className="settings-row">
          <label>Theme:</label>
          <select
            value={preferences.theme}
            onChange={(e) =>
              setPreferences({ ...preferences, theme: e.target.value })
            }
          >
            <option value="light">Light</option>
            <option value="dark">Dark</option>
          </select>
        </div>
        <div className="settings-row">
          <label>Language:</label>
          <select
            value={preferences.language}
            onChange={(e) =>
              setPreferences({ ...preferences, language: e.target.value })
            }
          >
            <option value="English">English</option>
            <option value="Spanish">Spanish</option>
          </select>
        </div>
        <button className="save-btn" onClick={savePreferences}>
          Save Preferences
        </button>
      </div>

      {/* ===== Avatar Modal ===== */}
      {avatarModal && (
        <div
          className="video-modal-overlay"
          onClick={() => setAvatarModal(false)}
        >
          <div
            className="video-modal-content"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="video-modal-header">
              <IoCloseOutline
                size={28}
                style={{ cursor: "pointer" }}
                onClick={() => setAvatarModal(false)}
              />
            </div>
            <h3>Upload Avatar</h3>
            <input
              type="file"
              onChange={(e) => setSelectedAvatar(e.target.files[0])}
            />
            <div style={{ marginTop: "15px" }}>
              <button className="save-btn" onClick={saveProfile}>
                Save
              </button>
              <button
                className="lesson-btn"
                style={{ marginLeft: "10px" }}
                onClick={() => setAvatarModal(false)}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Setting;
